import Icon from '../components/Icon.vue'

Icon.register({
  'compress-arrows-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M200 288H88C66.6 288 55.9 313.8 71 329L103.9 360 4.7 459.3C-1.5 465.5-1.5 475.7 4.7 481.9L30.1 507.3C36.3 513.5 46.5 513.5 52.7 507.3L152 408 183.1 441C198.2 456.1 224 445.4 224 424V312C224 298.7 213.3 288 200 288zM312 224H424C445.4 224 456.1 198.1 441 183L408 152 507.3 52.7C513.5 46.5 513.5 36.3 507.3 30.1L481.9 4.7C475.7-1.5 465.5-1.5 459.3 4.7L360 104 328.9 71C313.8 55.9 288 66.6 288 88V200C288 213.3 298.7 224 312 224zM408 360L441 328.9C456.1 313.8 445.4 288 424 288H312C298.7 288 288 298.7 288 312V424C288 445.4 313.9 456.1 329 441L360 408.1 459.3 507.4C465.5 513.6 475.7 513.6 481.9 507.4L507.3 482C513.5 475.8 513.5 465.6 507.3 459.4L408 360zM183 71.1L152 104 52.7 4.7C46.5-1.5 36.3-1.5 30.1 4.7L4.7 30.1C-1.5 36.3-1.5 46.5 4.7 52.7L104 152 71 183.1C55.9 198.2 66.6 224 88 224H200C213.3 224 224 213.3 224 200V88C224 66.7 198.1 56 183 71.1z'
      }
    ]
  }
})
